import { render } from "./RequestSubscriptionMagicLinkPage.vue?vue&type=template&id=6adaebb2&scoped=true"
import script from "./RequestSubscriptionMagicLinkPage.vue?vue&type=script&lang=js"
export * from "./RequestSubscriptionMagicLinkPage.vue?vue&type=script&lang=js"

import "./RequestSubscriptionMagicLinkPage.vue?vue&type=style&index=0&id=6adaebb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adaebb2"]])

export default __exports__